import anime from 'animejs'
import BaseController from '@/core/controller/BaseController'

/**
 *
 */
class JSScrollController extends BaseController {
  //
  private offsetY = 0

  /**
   * コンストラクタ
   *
   */
  constructor() {
    super()
  }

  /**
   * 実行
   */
  public run(elem: HTMLElement, center = false, duration = 700): void {
    const rect = elem.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    let scrollY = rect.top + scrollTop - this.offsetY

    if (center) {
      const winHeight = document.documentElement.clientHeight
      if (winHeight - this.offsetY > rect.height) {
        scrollY -= (winHeight - rect.height) / 2
      }
    }

    anime({
      targets: 'html,body',
      scrollTop: scrollY,
      duration: duration,
      easing: 'easeInOutSine',
    })
  }
}

export default JSScrollController
